import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../../hooks/useFetch";
import { Equipment, TriggerType } from "../../../../types/types";
import Spinner from "../../../../ui/Spinner/Spinner";
import TriggersGrid from "./TriggersGrid";

type TriggersContextType = {
  triggers: TriggerType[] | undefined;
  setTriggers: Function;
  equipment: Equipment;
};

export const TriggersContext = createContext<TriggersContextType | null>(null);

export const Triggers = ({ equipment }: { equipment: Equipment }) => {
  const { t } = useTranslation();

  // Получение данных и обновление их в сторе.
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/triggers`);
  const [triggers, setTriggers] = useState<TriggerType[]>();

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    let filteredTriggers = response.data as unknown as TriggerType[];
    filteredTriggers = filteredTriggers.filter(trigger => equipment.attributes.sensor_ids.includes(trigger.attributes.sensor_id!))
    setTriggers(filteredTriggers);
    setLoading(false);
  }, [response]);

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t("triggers")}</span>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <TriggersContext.Provider value={{ triggers: triggers, setTriggers: setTriggers, equipment: equipment }}>
          <TriggersGrid />
        </TriggersContext.Provider>
      )}
    </div>
  );
};
